
import '../post-table';
import '../post-table-item';

new Vue({
    el: '#app'
});

/**
 * ! Deprecated
 * Use Vue Component instead
 */
// var app = new Vue({
//     el: '#references',

//     data: {
        
//         /**
//          * All posts
//          */
//         posts: [],

//         /**
//          * All active filters
//          */
//         filter: [],

//         /**
//          * Active year filter
//          */
//         year: "",

//         /**
//          * Total amount of pages available
//          */
//         totalAvailablePages: null,

//         /**
//          * Active page
//          */
//         currentPage: 0,
        
//         /**
//          * Amount of posts to show per page
//          */
//         postsPerPage: 3
//     },

//     computed: {

//         /**
//          * Dynamic heading for the amount of posts
//          */
//         referenceCount: function() {
//             if (this.filter.length > 0) {
//                 return this.filteredPosts.length > 1 ? this.filteredPosts.length + ' Referenzen' : 'Eine Referenz';
//             }
//             return 'Alle Referenzen';
//         },

//         /**
//          * Different tags available in all posts
//          */
//         tags: function() {
//             let results = Object.create(null);

//             this.posts.forEach(function(post) {
//                 post.categories.forEach(function(cat) {
//                     /**
//                      * Overwrite, to push each category only once
//                      */
//                     results[cat.term_id] = cat.name;
//                 });
//             });

//             return results;
//         },

//         /**
//          * Different years available in all posts
//          */
//         yearsAvailable: function() {
//             let years = [];

//             this.posts.forEach(function(post) {
//                 let date = new Date(post.date).getFullYear();

//                 /**
//                  * Push each year only once
//                  */
//                 if (years.indexOf(date) === -1) {
//                     years.push(date);
//                 }
//             });

//             return years;
//         },

//         /**
//          * Posts filtered by active filter
//          */
//         filteredPosts: function(number) {
//             console.log('compute filtered posts...');

//             /**
//              * Get all posts by default
//              */
//             let vm = this, filteredPosts = this.posts;

//             /**
//              * Are there active category filters?
//              */
//             if (this.filter.length > 0) {
//                 filteredPosts = filteredPosts.filter(function(post) {

//                     /**
//                      * Get the id for every category of the post
//                      */
//                     let postCatIds = post.categories.map(function(cat) {
//                         return cat.term_id; 
//                     });
                    
//                     /**
//                      * Loop filters
//                      */
//                     for (let filterIndex = 0; filterIndex < vm.filter.length; filterIndex++) {
//                         let f = vm.filter[filterIndex];
//                         /**
//                          * Is the id of the filter found within the categories of the post?
//                          */
//                         if (postCatIds.indexOf(f) !== -1) {
//                             return true;
//                         }
//                     }

//                     return false;
//                 });
//             }

//             /**
//              * Is there a year filter?
//              */
//             if (this.year !== "") {
//                 /**
//                  * Loop posts
//                  */
//                 filteredPosts = filteredPosts.filter(function(post) {
//                     let date = new Date(post.date).getFullYear();
//                     /**
//                      * Does the post has this year?
//                      */
//                     return date === vm.year;
//                 });
//             }

//             return filteredPosts;
//         },

//         /**
//          * How many pages of posts are available for the current filter settings
//          */
//         filteredAvailablePages: function() {
//             return Math.ceil(this.filteredPosts.length / this.postsPerPage);
//         },

//         /**
//          * All posts for the current page
//          */
//         pagedPosts: function() {
//             console.log('current page', this.currentPage);
//             let offset = this.currentPage * this.postsPerPage;
//             let end = offset + this.postsPerPage;
//             let paged = this.filteredPosts.slice(offset, end);
//             console.log('computed paged posts, offset:', offset, 'end:', end);
            
//             return paged;
//         }
//     },

//     methods: {

//         /**
//          * Adds or removes filter
//          */
//         toggleFilter: function(tagId) {

//             let id = Number(tagId);

//             if (this.filter.includes(id)) {
//                 this.filter = this.filter.filter(function(el) {
//                     return el !== id;
//                 });
//             }
//             else {
//                 this.filter.push(id);
//             }

//             this.currentPage = 0;
//         },

//         /**
//          * Set current page to 0
//          */
//         resetCurrentPage: function() {
//             this.currentPage = 0;
//         },

//         /**
//          * Fetch page of posts for the given page index
//          */
//         fetchPage: function(pageIndex) {

//             if (this.totalAvailablePages && pageIndex > this.totalAvailablePages) {
//                 return;
//             }

//             let vm = this;

//             fetch('/wp-json/interessen-im-fluss/v1/referenzen/' + pageIndex)

//             .then(function(response) {
//                 vm.totalAvailablePages = Number(response.headers.get('WP-TotalPages'));
//                 return response.json();
//             })

//             .then(function(data) {
//                 vm.posts = vm.posts.concat(data);
//                 vm.fetchPage(pageIndex + 1);
//             });
//         },

//         /**
//          * Move forward to the given page
//          */
//         paginate: function(pageIndex) {
//             this.currentPage =  Number(pageIndex) - 1;
//         }
//     },

//     created: function() {
//         /**
//          * Start off by fetching the first page of posts
//          */
//         this.fetchPage(1);
//     }
// });
